import { Component } from '@angular/core';

@Component({
  selector: 'app-win-ols-solutions-version-comments',
  standalone: true,
  imports: [],
  templateUrl: './win-ols-solutions-version-comments.component.html',
  styleUrl: './win-ols-solutions-version-comments.component.css'
})
export class WinOlsSolutionsVersionCommentsComponent {

}
